import { dispatch } from "hf-rt";
import { ROOT } from "../constants";

const initialState = {
  autoLoginFormData: {
    mobileCountryCode: "",
    mobileNumber: "",
    password: ""
  }
};

export default {
  name: "register",
  actions: {
    goRegister: function() {
      // 前往註冊頁面
      dispatch({ type: "GO_REGISTER" });
      const element = document.getElementById("login");
      const content = document.getElementById("loginContent");
      // iframe 跳轉註冊會員頁面
      element.src = `${ROOT}/register`;
      // iframe 尺寸改變
      content.style.maxWidth = "1024px";
      content.style.width = "inherit";
      content.style.height = "1035px";
      content.style.margin = "5vh auto";
    },
    goCheckRegister: function(autoLoginFormData) {
      // 透過 postMessage 將自動登入的資訊帶給父層
      const formData = JSON.stringify(autoLoginFormData);
      if (window.opener) {
        window.opener.postMessage(`AUTO_LOGIN_FORM_DATA${formData}`, "*");
      } else if (window.parent) {
        window.parent.postMessage(`AUTO_LOGIN_FORM_DATA${formData}`, "*");
      }
      dispatch({ type: "GO_CHECK_REGISTER", autoLoginFormData });
      const element = window.parent.document.getElementById("login");
      const content = window.parent.document.getElementById("loginContent");
      // iframe 跳轉驗證簡訊碼頁面
      if (element) {
        element.src = `${ROOT}/check-register`;
      } else {
        window.location = `${ROOT}/check-register`;
      }
      // iframe 尺寸改變
      content.style.maxWidth = "1024px";
      content.style.width = "inherit";
      content.style.height = "400px";
      content.style.margin = "25vh auto";
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "GO_REGISTER":
        return { ...state };
      case "GO_CHECK_REGISTER":
        return { ...state, autoLoginFormData: action.autoLoginFormData };
      default:
        return state;
    }
  }
};
